import { Component } from '@angular/core';
import {  NbRequestPasswordComponent } from '@nebular/auth';

@Component({ 
  selector: 'ngx-request-password',
  templateUrl: './request-password.component.html',
})
export class NbxRequestPasswordComponent extends NbRequestPasswordComponent {
}
